import React, {useState} from 'react';
import {PhoneCountryField} from '@resurs-internal/mui';
import type {PhoneCountryFieldValue} from '@resurs-internal/mui/components/PhoneCountryField/PhoneCountryField';
import {useCountry} from '@resurs-internal/rb-app-api';
import {useTranslate} from '../../../hooks';
import type {VerifyContactFlow} from '../useVerifyContactFlow';
import {
  buildE164,
  callingCodeForCountry,
  parseE164,
  type NordicCountry,
} from '../utils/phoneE164';

export const PhoneField: React.FC<{flow: VerifyContactFlow}> = ({flow}) => {
  const {value, setValue, isBusy} = flow;
  const translate = useTranslate();
  const country = useCountry();

  const [initial] = useState<PhoneCountryFieldValue>(() =>
    initialPhoneValue(value, country.code),
  );

  return (
    <PhoneCountryField
      fullWidth
      outline={'single'}
      label={translate('common.mobile-phone')}
      initial={initial}
      disabled={isBusy}
      onChange={(v) => setValue(buildE164(v.callingCode, v.phoneNumber))}
    />
  );
};

const initialPhoneValue = (
  storedValue: string,
  countryCode: string,
): PhoneCountryFieldValue => {
  const parsed = parseE164(storedValue);
  if (parsed) {
    return {
      country: parsed.country,
      callingCode: parsed.callingCode,
      phoneNumber: parsed.localNumber,
    };
  }
  const fallback = (countryCode as NordicCountry) ?? 'SE';
  return {
    country: fallback,
    callingCode: callingCodeForCountry(fallback),
    phoneNumber: '',
  };
};
